const circleClips = document.querySelectorAll('#home-hero');

function removeIntro(element) {
   element.classList.remove('intro');
}

function circleMove(e) {
   circleClips.forEach(element => {
      removeIntro(element);
      gsap.to(element, {
         '--x': e.clientX + 'px',
         '--y': e.clientY + 'px',
         duration: 0.5, // Adjust the duration for smoothness
         ease: 'power2.out' // You can choose different easing functions
      });
   });
}

document.addEventListener('mousemove', circleMove);

circleClips.forEach(element => {
   element.addEventListener('touchmove', (e) => {
      removeIntro(element);
      let touch = e.touches[0];
      e.preventDefault();
      gsap.to(element, {
         '--x': touch.clientX + 'px',
         '--y': touch.clientY + 'px',
         duration: 0.5, // Adjust the duration for smoothness
         ease: 'power2.out' // You can choose different easing functions
      });
   });
});